import React from 'react';

export default function OrderFiltersBar({
  selectedStatus,
  setSelectedStatus,
  selectedType,
  setSelectedType,
  selectedPaymentStatus,
  setSelectedPaymentStatus,
  dateFilter,
  setDateFilter,
  customStartDate,
  setCustomStartDate,
  customEndDate,
  setCustomEndDate,
  searchTerm,
  setSearchTerm,
  setStatusPreset,
  hasNonIndianOrders,
  showDisputeView,
  setShowDisputeView,
}) {
  return (
    <div className="filters-container">
  <div className="filter-group">
    <label>Status</label>
    <select 
      value={selectedStatus} 
      onChange={(e) => {
        setStatusPreset('none');
        setSelectedStatus(e.target.value);
      }}
      className="status-filter"
    >
      <option value="all">All Orders</option>
      <option value="unfulfilled">Order Placed</option>
      <option value="preorder_received">Preorder Placed</option>
      <option value="progress">Production Update</option>
      <option value="delay">Delay Update</option>
      <option value="stock_in">Stock Arrived</option>
      <option value="packing">Packing Started</option>
      <option value="shipping_domestic">Shipped Domestic</option>
      {/* Show International Shipping only if there are non-Indian orders */}
      {hasNonIndianOrders() && (
        <option value="shipping_international">Shipped International</option>
      )}
      <option value="arrived_at_destination">Arrived in Destination Country</option>
      <option value="out_of_delivery">Out for Delivery</option>
      <option value="destoryed">Customs Cleared</option>
      <option value="delivered">Delivered</option>
      <option value="review">Review Request</option>
      <option value="dispute">Issue Reported</option>
      <option value="replacement_approved">Replacement Approved</option>
      <option value="replacement_packing">Replacement Packed</option>
      <option value="replacement_shipping_domestic">Replacement Shipped Domestic</option>
      <option value="replacement_shipping_international">Replacement Shipped International</option>
      <option value="replacement_delivered">Replacement Delivered</option>
      <option value="refunded">Refund Processed</option>
    </select>
  </div>

  <div className="filter-group">
    <label>Type</label>
    <select 
      value={selectedType} 
      onChange={(e) => {
        setStatusPreset('none');
        setSelectedType(e.target.value);
      }}
      className="type-filter"
    >
      <option value="all">All Types</option>
      <option value="regular">Regular Orders</option>
      <option value="preorder">Preorders</option>
    </select>
  </div>

  <div className="filter-group">
    <label>Payment</label>
    <select
      value={selectedPaymentStatus}
      onChange={(e) => {
        setStatusPreset('none');
        setSelectedPaymentStatus(e.target.value);
      }}
      className="payment-filter"
    >
      <option value="all">All Payments</option>
      <option value="paid">Paid</option>
      <option value="partially_paid">Partially Paid</option>
      <option value="refunded">Refund</option>
      <option value="partially_refunded">Partially Refunded</option>
      <option value="pending">Pending</option>
      <option value="authorized">Authorized</option>
      <option value="voided">Voided</option>
    </select>
  </div>

  <div className="filter-group">
    <label>Date</label>
    <select 
      value={dateFilter} 
      onChange={(e) => {
        setStatusPreset('none');
        setDateFilter(e.target.value);
        // Clear custom dates when switching away from custom
        if (e.target.value !== 'custom') {
          setCustomStartDate('');
          setCustomEndDate('');
        }
      }}
      className="date-filter"
    >
      <option value="today">Today </option>
      <option value="7days">Last 7 Days</option>
      <option value="1month">Last 1 Month</option>
      <option value="3months">Last 3 Months</option>
      <option value="all">All Time</option>
      <option value="custom">Custom Range</option>
    </select>
  </div>

  {dateFilter === 'custom' && (
    <>
      <div className="filter-group">
        <label>From Date:</label>
        <input
          type="date"
          value={customStartDate}
          onChange={(e) => setCustomStartDate(e.target.value)}
          className="date-input"
        />
      </div>
      <div className="filter-group">
        <label>To Date:</label>
        <input
          type="date"
          value={customEndDate}
          onChange={(e) => setCustomEndDate(e.target.value)}
          className="date-input"
        />
      </div>
    </>
  )}

  <div className="filter-group filter-search">
    <label>Search</label>
    <div className="search-container">
      <input
        type="text"
        placeholder="Search by order #, email, customer name, or product..."
        value={searchTerm}
        onChange={(e) => {
          const value = e.target.value;
          setSearchTerm(value);
        }}
        className="search-input"
      />
      {searchTerm && (
        <button
          onClick={() => {
            setSearchTerm('');
          }}
          className="clear-search-btn"
          title="Clear search"
        >
          ✕
        </button>
      )}
    </div>
  </div>

  <div className="filter-actions-row">
    <div className="filter-group filter-action-group">
      <label>&nbsp;</label>
      <button 
        onClick={() => {
          setDateFilter('today');
          setSelectedStatus('all');
          setSelectedType('all');
          setSelectedPaymentStatus('all');
          setStatusPreset('none');
          setSearchTerm('');
          setCustomStartDate('');
          setCustomEndDate('');
        }}
        className="reset-filters-btn"
      >
        Reset Filters
      </button>
    </div>

    <div className="filter-group filter-action-group">
      <label>&nbsp;</label>
      <button 
        onClick={() => setShowDisputeView(!showDisputeView)}
        className={`dispute-management-btn ${showDisputeView ? 'active' : ''}`}
        title="View and manage all disputes"
      >
        {showDisputeView ? 'Hide' : 'View'} Disputes
      </button>
    </div>
  </div>
</div>
  );
}
